import { httpsCallable } from "firebase/functions";
const TWO_WEEKS_IN_MS = 14 * 24 * 60 * 60 * 1000;
export class FundsApiService {
    constructor(functions, storage) {
        this.functions = functions;
        this.storage = storage;
    }
    loadCache(accountId) {
        const cachedData = this.storage.getItem(`cachedFundsTransactions_${accountId}`);
        const cachedTime = this.storage.getItem(`lastFetchTime_${accountId}`);
        return {
            cachedFundsTransactions: cachedData ? JSON.parse(cachedData) : null,
            lastFetchTime: cachedTime ? parseInt(cachedTime, 10) : 0,
        };
    }
    saveCache(accountId, data) {
        this.storage.setItem(`cachedFundsTransactions_${accountId}`, JSON.stringify(data));
        this.storage.setItem(`lastFetchTime_${accountId}`, Date.now().toString());
    }
    async getFundsTransactions(accountId, ignoreCache = false) {
        try {
            const { cachedFundsTransactions, lastFetchTime } = this.loadCache(accountId);
            const currentTime = Date.now();
            if (!ignoreCache && cachedFundsTransactions && (currentTime - lastFetchTime) < TWO_WEEKS_IN_MS) {
                return cachedFundsTransactions;
            }
            const getFundsData = httpsCallable(this.functions, 'getFundsTransactions');
            const result = await getFundsData({ accountId });
            console.log("FundsApi.getFundsTransactions response:", result);
            const response = result.data;
            console.log("FundsApi.getFundsTransactions response:", response);
            // Update the cache
            this.saveCache(accountId, response);
            return response;
        }
        catch (e) {
            console.error("FundsApi.getFundsTransactions error:", e);
            return undefined;
        }
    }
    async addTransaction(accountId, type, amount, date) {
        try {
            const addFundsTransaction = httpsCallable(this.functions, 'addFundsTransaction');
            const result = await addFundsTransaction({ accountId, type, amount, date });
            console.log("FundsApi.addTransaction response:", result);
            return result;
        }
        catch (e) {
            console.error("FundsApi.addTransaction error:", e);
            return undefined;
        }
    }
}
